import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ContentCellEditor.html?raw';


//import Button = require("../../../moreCore/UI/Button/Button");
//import "../../../moreCore/UI/Button/Button";

import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";

import "../OrchestraMatrixWsyTypes";


class ContentCellEditor extends compose(_WidgetBaseSP) {
    templateString: any = template;

    replacementMusicanSelect: MdsLax<InstanceType<typeof SearchSelect>>;
    scheduledMusicanSelect: MdsLax<InstanceType<typeof SearchSelect>>;

    musicanNode: HTMLDivElement;
    dutyTypeNode: HTMLDivElement;

    private _dataX: OrchestraMatrixWsy_ItemContainer<OrchestraMatrixWsy_DataItem_X> = null;
    private _dataY: OrchestraMatrixWsy_ItemContainer<OrchestraMatrixWsy_DataItem_X> = null;
    private _dataItem: OrchestraMatrixWsy_DataItem_Content = null;
    private _data_Content: OrchestraMatrixWsy_ItemContainer<OrchestraMatrixWsy_DataItem_Content> = null;

    private musicanReplacementContainerNode: HTMLDivElement;
    private musicanScheduledContainerNode: HTMLDivElement;


    setData(dataItem: OrchestraMatrixWsy_DataItem_Content, dataX: OrchestraMatrixWsy_ItemContainer<OrchestraMatrixWsy_DataItem_X>, dataY: OrchestraMatrixWsy_ItemContainer<OrchestraMatrixWsy_DataItem_X>, allContentData: OrchestraMatrixWsy_ItemContainer<OrchestraMatrixWsy_DataItem_Content>) {

        this._dataItem = dataItem;
        this._dataX = dataX;
        this._dataY = dataY;
        this._data_Content = allContentData;

        let valueList = [];

        this.hideNode(this.musicanScheduledContainerNode, true);
        this.hideNode(this.musicanReplacementContainerNode, true);

        if (this._dataItem.label == "XT") { // anwesend als tauscher
            this.hideNode(this.musicanScheduledContainerNode, false);
        }

        if (this._dataItem.label == "XE") { // nicht anwesend aber eigneteilt
            this.hideNode(this.musicanReplacementContainerNode, false);
        }

        // alle Musiker durchlaufen
        //
        for (let i = 0; i < this._dataX.items.length; i++) {
            const item = this._dataX.items[i];

            if (item.entityID == this._dataItem.ref_x) {
                this.musicanNode.innerText = item.labelRaw;
            }

            if (!item.labelRaw || item.type != "entity") {
                continue;
            }

            let lookupDutyType = null;
            if (this._dataItem.label == "XT") {
                lookupDutyType = "XE"; //  wenn der aktuelel dienst ein tausche rist suchen wir einen eingeteilten
            } else if (this._dataItem.label == "XE") {
                lookupDutyType = "XT"; // wir suchen einen tauscher
            }

            // prüfen ob zum Musiker ein Tausch vorhanden ist (XE/XT)
            for (let x = 0; x < this._data_Content.items.length; x++) {
                let contentItem = this._data_Content.items[x];
                if ((contentItem.ref_x == item.ID && contentItem.ref_x != this._dataItem.ref_x) && (contentItem.label == lookupDutyType)) { // nicht sich selbst...
                    // der Musiker hat einen Dienst mit XE/XT.. kann also in die Liste aufgenommen werden
                    // noch prüfen ob noch keine Zuweisung vorhanden ist

                    if (this._dataItem.ref_y == contentItem.ref_y) { // auch schauen ob das event passt

                        if (((this._dataItem.label == "XE" && contentItem.ref_replacement_musican == null) || (this._dataItem.label == "XT" && contentItem.ref_scheduled_musican == null)) ){
                        /*if (contentItem.ref_replacement_musican == null && contentItem.ref_scheduled_musican == null &&
                            (
                                this._dataItem.label == "XE" || this._dataItem.label == "XT" 
                            )
                        ) {*/
                            valueList.push({
                                "label": item.labelRaw,
                                "value": item.entityID
                            });
                        }
                        break;
                    }
                }
            }
        }

        console.log("dataX", this._dataX);
        console.log("dataY", this._dataY);


        this.replacementMusicanSelect.setData(this._dataItem.ref_replacement_musican?.value, valueList, true, "label", "value");
        this.scheduledMusicanSelect.setData(this._dataItem.ref_scheduled_musican?.value, valueList, true, "label", "value");

        this.dutyTypeNode.innerText = this._dataItem.label;
    }

    getDataItem(): OrchestraMatrixWsy_DataItem_Content {
        return this._dataItem;
    }

    _onChange_ScheduledMusican(): void {
        let entity = this.scheduledMusicanSelect.getValue(true);
        console.log("_onChange_ScheduledMusican - HIER ist der XT Dienst - gesetzt wird der Eingeteilte", entity);
        if (this._dataItem.ref_replacement_musican == null && this._dataItem.ref_scheduled_musican == null) {
            this._dataItem.ref_scheduled_musican = entity;
        }

        if (entity == null) {
            this._dataItem.ref_scheduled_musican = null;
            this._dataItem.ref_replacement_musican = null; // wenn null, dann alles leeren
            this._dataItem.individualColor = null;
        } else {
            // prüfen ob weitere nicht zugewiesene dataitems zum selben ref_x existieren
            for (let i = 0; i < this._data_Content.items.length; i++) {
                let otherItem = this._data_Content.items[i];

                if (otherItem != this._dataItem
                    && otherItem.ref_x == this._dataItem.ref_x
                    && otherItem.label == "XT"
                    && otherItem.ref_scheduled_musican == null
                    && otherItem.ref_replacement_musican == null) {
                    otherItem.ref_scheduled_musican = entity;

                    this.emit("onSetScheduledMusican", otherItem);
                }
            }
        }

        this.emit("onSetScheduledMusican", this._dataItem);
    }

    _onChange_ReplacementMusican(): void {
        let entity = this.replacementMusicanSelect.getValue(true);
        console.log("_onChange_ReplacementMusican - HIER ist der XE Dienst - gesetzt wird der Tauscher", entity);

        if (this._dataItem.ref_replacement_musican == null && this._dataItem.ref_scheduled_musican == null) {
            this._dataItem.ref_replacement_musican = entity;
        }

        if (entity == null) {
            this._dataItem.ref_replacement_musican = null; // wenn null, dann alles leeren
            this._dataItem.ref_scheduled_musican = null;
            this._dataItem.individualColor = null;
        } else {
            // prüfen ob weitere nicht zugewiesene dataitems zum selben ref_x existieren
            for (let i = 0; i < this._data_Content.items.length; i++) {
                let otherItem = this._data_Content.items[i];

                if (otherItem != this._dataItem
                    && otherItem.ref_x == this._dataItem.ref_x
                    && otherItem.label == "XE"
                    && otherItem.ref_scheduled_musican == null
                    && otherItem.ref_replacement_musican == null) {
                    otherItem.ref_replacement_musican = entity;

                    this.emit("onSetReplacementMusican", otherItem);
                }
            }
        }

        this.emit("onSetReplacementMusican", this._dataItem);

    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }


    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ContentCellEditor);